module.exports = __webpack_public_path__ + "images/marker-studie.417aa0.png";